import { render, staticRenderFns } from "./transData.vue?vue&type=template&id=7ed87f42&"
import script from "./transData.vue?vue&type=script&lang=js&"
export * from "./transData.vue?vue&type=script&lang=js&"
import style0 from "./transData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports